import React, { useState, useEffect } from "react";
const DashboardAdmin = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(timer); 
  }, []);

  return (
    <>
      <div className="flex-grow-1 p-4">
        <div className="card bg-info">
          <div className="card-body text-start">
          <div className="text-white">
            <h1 className="card-title">Welcome to Admin Dashboard</h1>
          </div>
          <p className="text-white"><strong>Date:</strong> {currentDateTime.toLocaleDateString()}</p>
          <p className="text-white"><strong>Time:</strong> {currentDateTime.toLocaleTimeString()}</p>
        </div>
        </div>
        </div> 
            
        {/* <table className='table table-striped'>
            <thead>
            <tr>
              <th>Sr No</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            {
              examList && examList.map((item, index) => (
                
                <tr>
                  <td>{index}</td>
                  <td>{item.exam_name}</td>
                  <td>{item.duration}</td>
                  <td>{item.total_questions}</td>
                  <td>{item.subject_id}</td>
                  <td>
                    <button onClick={startExam} className='btn btn-primary'>Start Exam</button>
                  </td>
                </tr>
              ))
            }
            </tbody>
          </table> */}

    </>
  )
}

export default DashboardAdmin